// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import "babel-polyfill";
import iView from 'iview';
import '../../../my-theme/index.less';
import util from '@commonjs/util.js';


Vue.config.productionTip = false;
Vue.prototype.ajax = util.JAjax;
Vue.prototype.aUrl = util.url;

Vue.use(iView);

var vm = new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
});


